export default "__VITE_ASSET__CU1g18JX__"